import { css } from '@emotion/core'
import React from 'react'
import { NoticeLoading } from '@fs/zion-icon'
import { Body1 } from '@fs/zion-ui'

const PageLoadingIndicator = ({ constrain, label = '', ...noticeProps }) => {
  const cssLoading = css`
    width: ${constrain ? '100%' : '100vw'};
    height: ${constrain ? '30vh' : '100vh'};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `
  return (
    <div css={cssLoading}>
      <Body1>{label}</Body1>
      <NoticeLoading size="xl" {...noticeProps} />
    </div>
  )
}

export default PageLoadingIndicator
